import * as React from 'react'
import { CreateAgreementsDrawer } from '@user/components/Agreements/CreateAgreementDrawer/CreateAgreementDrawer'
import { ENTITY_TYPES } from '@sales-center/common'
import { ViewAgreementsDrawer } from '@user/components/Agreements/ViewAgreementsDrawer/ViewAgreementsDrawer'
import { CreateLocationDrawer } from '@user/components/Agreements/CreateLocationDrawer/CreateLocationDrawer'
import { OppStatus } from '../../../Opportunities/OpportunityCard/typings'
import { LEAD_STATUSES } from '../../../Leads/LeadCard/typings'
import { ClosingRequirement } from '../../ClosingRequirement'
import { AgreementIcon } from '@sales-center/components'
import { useData, useHandlers } from './hooks'
import { AgreementFormPacketDialog } from '@user/components/Agreements/AgreementFormPacketDialog/AgreementFormPacketDialog'
import { ISalesFunnel } from '@user/store/salesFunnel'

export type Props = {
  count: number
  entityId: number
  entityType: ENTITY_TYPES
  externalLocationId: string
  isComplete: boolean
  leadStatus?: LEAD_STATUSES
  openServicesDrawer: () => void
  servicesCount: number
  oppStatus?: OppStatus
  canUpdate: boolean
  salesFunnel: ISalesFunnel | undefined

  openCreateDrawer: () => void
  createDrawerOpen: boolean
  setCreateDrawerOpen: (open: boolean) => void
}

export function AgreementRequirements(props: Props) {
  const {
    canUpdate,
    count,
    entityId,
    entityType,
    externalLocationId,
    isComplete,
    openServicesDrawer,
    openCreateDrawer,
    createDrawerOpen,
    setCreateDrawerOpen,
  } = props

  const { disabledText, isDisabled, formPacketEnabled, enableCreateAgreement } =
    useData(props)

  const {
    viewDrawerOpen,
    closeViewDrawer,
    cancelPopupOpen,
    closeCreateDrawer,
    onCloseFormManager,
    createLocationDrawerOpen,
    closeCreateServiceDrawer,
    openCreateServiceDrawer,
    hideCancelDialog,
    handleCancel,
  } = useHandlers({
    entityId,
    entityType,
    formPacketEnabled,
    createDrawerOpen,
    setCreateDrawerOpen,
  })

  return (
    <>
      <ClosingRequirement
        entityId={entityId}
        count={count}
        title="Agreement"
        buttonText="Create Agreement"
        linkText="Agreements"
        isComplete={isComplete}
        isDisabled={!enableCreateAgreement && isDisabled}
        isDisabledText={disabledText}
        icon={<AgreementIcon />}
        buttonClick={() => openCreateDrawer()}
        requirement="agreement"
      />

      <ViewAgreementsDrawer
        entityId={entityId}
        entityType={entityType}
        onClose={closeViewDrawer}
        open={viewDrawerOpen}
        canUpdate={canUpdate}
        openAgreementCreateDrawer={openCreateDrawer}
      />

      {formPacketEnabled ? (
        createDrawerOpen && (
          <AgreementFormPacketDialog
            entityId={entityId}
            entityType={entityType}
            onClose={closeCreateDrawer}
            onCloseFormManager={onCloseFormManager}
            open={createDrawerOpen}
            openServicesDrawer={openServicesDrawer}
            cancelPopupOpen={cancelPopupOpen}
            handleCancel={handleCancel}
            cancelPopupClose={hideCancelDialog}
          />
        )
      ) : (
        <CreateAgreementsDrawer
          entityId={entityId}
          entityType={entityType}
          externalLocationId={externalLocationId}
          onClose={closeCreateDrawer}
          open={createDrawerOpen}
          openServicesDrawer={openServicesDrawer}
          openCreateServiceDrawer={openCreateServiceDrawer}
        />
      )}

      <CreateLocationDrawer
        entityId={entityId}
        entityType={entityType}
        onClose={closeCreateServiceDrawer}
        open={createLocationDrawerOpen}
        externalLocationId={externalLocationId}
      />
    </>
  )
}
